<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="editUserModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editUserModalLabel">Editing User Details</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="">Full Names</label>
                <input :readonly="!getRight('EDIT ALL USER DETAILS')" v-model="formData.names" type="text" class="form-control" placeholder="Enter The Full Names">
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="">ID Number</label>
                <input :readonly="!getRight('EDIT ALL USER DETAILS')" v-model="formData.idNo" type="text" class="form-control" placeholder="Enter ID No.">
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="">Gender</label>
                <select :disabled="!getRight('EDIT ALL USER DETAILS')" class="form-select" v-model="formData.gender">
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="">Phone Number</label>
                <input :readonly="!getRight('EDIT ALL USER DETAILS')" v-model="formData.phoneNumber" type="text" class="form-control" placeholder="Enter Phone Number">
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="">Email Address</label>
                <input :readonly="!getRight('EDIT ALL USER DETAILS')" v-model="formData.email" type="email" class="form-control" placeholder="email@email.com">
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="" class="mb-0 pb-0">User Role/Designation</label>
                <p><small>Select The role that this user is expected to undertake while using the system</small></p>
                <select class="form-select" v-model="formData.category">
                  <option v-for="(item, index) in categories" :key="`${index}`" :value="item.category">{{item.category}}</option>
                </select>
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="" class="mb-0 pb-0">SubCounty</label>
                <p><small>Select the sub county</small></p>
                <select class="form-select" @change="handleSubCountyChange" v-model="formData.subCountyID">
                  <option value="">Select SubCounty</option>
                  <option v-for="(item, index) in subCounties" :key="`${index}`" :value="item.subCountyID">{{item.subCountyName}}</option>
                </select>
              </div>
            </div>

            <div class="col-6 mb-3">
              <div class="form-group">
                <label for="" class="mb-0 pb-0">Ward</label>
                <p><small>Select the ward</small></p>
                <select class="form-select" v-model="formData.wardID">
                  <option value="">Select Ward</option>
                  <option :key="`${index}`" :value="item.wardID" v-for="(item, index) in wards">{{item.wardName}}</option>
                </select>
              </div>
            </div>

            <div class="col-12 mb-3">
              <div class="form-group">
                <label for="" class="mb-0 pb-0">Zone(s)</label>
                <p><small>Select the zone(s) the user has been assigned to. To select multiple zones hold <strong class="fw-semibold">CTRL</strong> and select the zones.</small></p>
                <select class="form-select" v-model="formData.zone" multiple>
                  <option v-for="(item, index) in zones" :key="`${index}`" :value="item.zone">{{item.zone}}</option>
                </select>
              </div>
            </div>

            <div class="col-12">
              <label>
                <input type="checkbox" v-model="formData.requireOTP">
                Require OTP for login
              </label>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="handleSave" class="btn btn-primary w-100" title="Click to save">SAVE</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>
import {getRight} from "@/api";

export default {
  name: "EditUserModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    },
    categories: {
      type: Array,
      default: () => []
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    },
    zones: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {
        names: '',
        idNo: '',
        gender: '',
        category: '',
        phoneNumber: '',
        email: '',
        subCountyID: '',
        subCountyName: '',
        wardID: '',
        wardName: '',
        zone: [],
        requireOTP: false,
        id: null
      }
    }
  },
  watch: {
    selectedUser: {
      handler(newUser) {
        if (newUser && Object.keys(newUser).length > 0) {
          this.formData = {
            names: newUser.names || '',
            idNo: newUser.idNo || '',
            gender: newUser.gender || '',
            category: newUser.category || '',
            phoneNumber: newUser.phoneNumber || '',
            email: newUser.email || '',
            subCountyID: newUser.subCountyID || '',
            subCountyName: newUser.subCountyName || '',
            wardID: newUser.wardID || '',
            wardName: newUser.wardName || '',
            zone: this.parseZone(newUser.zone),
            requireOTP: newUser.requireOTP === 'true',
            id: newUser.id
          };

          // Emit subcounty change to load wards if needed
          if (newUser.subCountyID) {
            this.$emit('subcounty-change', newUser.subCountyID);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    findSubCountyName(subCountyID) {
      const subCounty = this.subCounties.find(sc => sc.subCountyID === subCountyID);
      return subCounty ? subCounty.subCountyName : '';
    },

    findWardName(wardID) {
      const ward = this.wards.find(w => w.wardID === wardID);
      return ward ? ward.wardName : '';
    },

    parseZone(zoneString) {
      if (!zoneString) return [];
      return Array.isArray(zoneString) ? zoneString : [zoneString];
    },

    handleSubCountyChange() {
      // Update the subCountyName when subCountyID changes
      this.formData.subCountyName = this.findSubCountyName(this.formData.subCountyID);
      // Emit event to load wards for the selected subcounty
      this.$emit('subcounty-change', this.formData.subCountyID);
      // Reset ward selection when subcounty changes
      this.formData.wardID = '';
      this.formData.wardName = '';
    },

    handleSave() {
      if (!this.formData.names ||
          !this.formData.phoneNumber ||
          !this.formData.idNo ||
          !this.formData.category ||
          this.formData.zone.length === 0) {
        alert("Fill all the required fields");
        return;
      }

      // Update ward name before saving
      if (this.formData.wardID) {
        this.formData.wardName = this.findWardName(this.formData.wardID);
      }

      // Update subcounty name before saving
      if (this.formData.subCountyID) {
        this.formData.subCountyName = this.findSubCountyName(this.formData.subCountyID);
      }

      const userData = {
        ...this.formData,
        requireOTP: this.formData.requireOTP
      };

      this.$emit('save', userData);
    }
  }
}
</script>

<style scoped>
/* Optional: Add any custom styling here */
</style>